module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/158-egypt-ab69a405c71a58a6dd0292e6caebd724.svg";